import '../scss/style.scss';
import '../scss/tailwind.css';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';

document.addEventListener('DOMContentLoaded', () => {

  const menuBtn = document.querySelector('.menu-btn-mobile');
  const menuBtnIcon = document.querySelector('.menu-btn-icon-mobile i');
  const menuMobile = document.querySelector('.menu-mobile');
  if (menuBtn) {
    menuBtn.addEventListener('click', (e) => {
      e.preventDefault();
      menuBtn.classList.toggle('active');
      menuBtn.classList.toggle('max-[680px]:-rotate-360');
      menuBtnIcon.classList.toggle('fa-xmark');
      menuMobile.classList.toggle('max-[680px]:!translate-x-[0%]');
    });
  }

  document.querySelectorAll('.video-youtube-parent').forEach((parent) => {
    const playTriggers = parent.querySelectorAll('.play-video');
    const poster = parent.querySelector('.poster-section');
    const iframe = parent.querySelector('iframe');

    playTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        poster.style.display = 'none';

        const src = iframe.getAttribute('src');
        if (!src.includes('autoplay=1')) {
          const newSrc = src.includes('?')
            ? `${src}&autoplay=1`
            : `${src}?autoplay=1`;
          iframe.setAttribute('src', newSrc);
        }
      });
    });
  });

  const parentRadial = document.querySelector('.parent-radial');

  if (parentRadial) {
    const bgBlue = parentRadial.querySelector('.radial-gr');
    parentRadial.addEventListener('mousemove', (e) => {
      const rect = parentRadial.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const percentage = Math.min(
        Math.max((mouseX / rect.width) * 100, 0),
        100
      );
      /* console.log(percentage); */
      bgBlue.style.setProperty('--p', `${percentage}%`);
    });
  }

  const swiper = new Swiper('.swiper-cards', {
    modules: [Navigation, Pagination],
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        spaceBetween: 30,
        slidesPerView: 1.1,
      },
      700: {
        spaceBetween: 30,
        slidesPerView: 1.5,
      },
      960: {
        spaceBetween: 30,
        slidesPerView: 2.4,
      },
      1200: {
        spaceBetween: 30,
        slidesPerView: 3.2,
      },
      1400: {
        spaceBetween: 30,
        slidesPerView: 3.1,
      },
      1700: {
        spaceBetween: 30,
        slidesPerView: 2.9,
      },
    },
  });

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -10px 0px',
    threshold: 0.1,
  };

  const handleIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const element = entry.target;

        element.classList.add('animate-active');
      }
    });
  };

  const observer = new IntersectionObserver(
    handleIntersection,
    observerOptions
  );

  const animatedElements = document.querySelectorAll('.animate-on-scroll');
  animatedElements.forEach((element) => {
    observer.observe(element);
  });

  window.reinitAnimations = function () {
    const newElements = document.querySelectorAll(
      '.animate-on-scroll:not(.animate-active)'
    );
    newElements.forEach((element) => {
      observer.observe(element);
    });
  };

  const logoSliderInfo = '.swiper-info';
  if (document.querySelector(logoSliderInfo)) {
    const swiperInfo = new Swiper(logoSliderInfo, {
      loop: document.querySelectorAll('.swiper-info .swiper-slide').length > 2,
      slidesPerView: 1,
      modules: [Autoplay],
      spaceBetween: 0,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  }
  
  const swiperLogos = '.swiper-logos';
  if (document.querySelector(swiperLogos)) {
    const swiperInfo = new Swiper(swiperLogos, {
      loop: document.querySelectorAll('.swiper-logos .swiper-slide').length > 2,
      slidesPerView: 5,
      modules: [Autoplay],
      spaceBetween: 0,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        520: {
          slidesPerView: 2,
        },
        700: {
          slidesPerView: 3,
        },
        960: {
          slidesPerView: 5,
        },
      },
    });
  }
});
